// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"50419c32","286":"b4cd343c","473":"7b5218e4","666":"0b9d4960","764":"e0d886cc","867":"f2c91dcf"}[chunkId] + ".chunk.js";
};